import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumbs from '@/components/feature/Breadcrumbs';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function Articles() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="文章中心 - 开云平台"
        description="开云平台文章中心，为您提供平台入门指南、功能教程、使用场景、最佳实践等丰富内容，助您全面掌握开云平台。"
        keywords="开云文章,开云使用指南,开云教程,开云功能介绍,开云最佳实践"
        canonicalUrl="https://kaiyun.example.com/articles"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <Breadcrumbs items={[{ label: '首页', path: '/' }, { label: '文章中心' }]} />
          </div>

          <section className="pb-16">
            <div className="max-w-7xl mx-auto px-4 md:px-6">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-2">文章中心</h1>
              <p className="text-sm text-foreground-600 mb-10">浏览全部文章，获取开云平台的最新指南与行业洞察</p>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {articles.map((article) => {
                  const cat = categories.find((c) => c.id === article.categoryId);
                  return (
                    <Link
                      key={article.id}
                      to={`/articles/${article.slug}`}
                      className="group rounded-xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300"
                    >
                      <div className="h-48 overflow-hidden relative">
                        <img
                          src={article.image}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                        {cat && (
                          <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm text-xs font-medium text-foreground-700">
                            {cat.name}
                          </span>
                        )}
                      </div>
                      <div className="p-5">
                        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
                          <span>{article.date}</span>
                          <span>·</span>
                          <span>{article.author}</span>
                        </div>
                        <h2 className="text-base font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                          {article.title}
                        </h2>
                        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>
                      </div>
                    </Link>
                  );
                })}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}